<p-toast></p-toast>

<div
	*ngIf="loading"
	class="flex align-items-center justify-content-center m-0 p-0"
>
	<p-progressSpinner></p-progressSpinner>
</div>

<div class="w-100 text-center">
	<div class="w-100" *ngIf="investment">
    <div class="grid">
      <div class="col-12">
        <h5 class="text-white font-bold">SALDO ACTUAL: {{formatNumber(investment.total)}}{{ getCurrencySymbol(investment.currency) }} <i></i></h5> 
        <p class="text-white">{{investment.start_date | date: 'dd-MM-yyyy' }} - {{investment.end_date | date: 'dd-MM-yyyy'}}</p>
        <div class="interest">
          Interés est. {{formatNumber(investment.interest)}}%
        </div>
        <p>
        </p>
      </div>
    </div>
  </div>
    <div class="grid">
      	<div class="col-12">
		<div style="position: block; height: 450px; width: 100%;max-width: 550px;margin:auto;">
		<canvas #barCanvas></canvas>
		</div>
		</div>
	</div>

	<div class="grid text-center mt-5 w-100" *ngIf="transactions.length == 0">
		<h5 class="font-bold text-white  m-auto">Sin transacciones</h5>
	</div>
	<div class="grid mx-5 mt-5" *ngIf="transactions.length > 0">
		<h4 class="font-bold text-white">Tus transacciones</h4>
	</div>
	<div class="grid mx-5 mt-2" *ngIf="transactions.length > 0">
		<p-table
		  #dt1
		  [value]="transactions"
		  dataKey="id"
		  [rows]="100"
		  [loading]="loading"
		  [rowHover]="true"
		  paginator="false"
		  responsiveLayout="scroll"
		  [sortField]="'transaction_date'"
		  [sortOrder]="-1"
		>
		  <ng-template pTemplate="header">
			<tr>
				<th [style.width]="'220px'" pSortableColumn="transaction_date" class="text-center">
					Fecha <p-sortIcon field="transaction_date"></p-sortIcon>
				</th>
				<th class="text-center">Importe</th>
				<th>Descripción</th>
			</tr>
		  </ng-template>
  
		  <ng-template pTemplate="body" let-transaction>
			<tr>
				<td class="text-center font-bold">
					{{transaction.transaction_date | date: 'dd-MM-yyyy'  }}
				</td>
				<td class="text-center">
					<p class="font-bold" [ngClass]="{'text-success':transaction.type == 'deposito', 'text-danger':transaction.type != 'deposito', }">{{transaction.type == 'deposito' ? '+':'-'}} {{formatNumber(transaction.amount)}} {{ getCurrencySymbol(investment?.currency) }}
					</p>
				</td>
				<td>
					<p>{{transaction.description}}</p>
				</td>
			</tr>
		  </ng-template>
  
		  <ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="8" class="text-center">Sin resultados</td>
			</tr>
		  </ng-template>
  
		  <ng-template pTemplate="loadingbody">
			<tr>
			  <td colspan="8">Cargando inversiones...</td>
			</tr>
		  </ng-template>
		</p-table>
	</div>
</div>